// extracted by mini-css-extract-plugin
export default {"carousel":"CarouselBrands_carousel__gealK","brand":"CarouselBrands_brand__WdnhR"};